import React from "react";
import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Cat5e from "./Cat5e";
import Cat6 from "./Cat6";
import Cat6a from "./Cat6a";
import Cat7 from "./Cat7";
import Cat8 from "./Cat8";
import Fiber from "./Fiber";
import CabosImg from "../../../assets/images/cabos.png";
import CabosEthernet from "../../../assets/images/cabosEthernet.png";
import Gbic from "../../../assets/images/gbic.png";
import Rj45 from "../../../assets/images/rj45.png";
import Alicate from "../../../assets/images/alicateCrimpador.png";
import Keystone from "../../../assets/images/keystone.png";
import Pushdown from "../../../assets/images/pushDown.png";

import Testador1 from "../../../assets/images/testador1.png";
import Testador2 from "../../../assets/images/testador2.png";
import Testador3 from "../../../assets/images/testador3.png";
import Testador4 from "../../../assets/images/testador4.png";
import Localizador from "../../../assets/images/localizador.png";
import Localizador2 from "../../../assets/images/localizador2.png";
import T568a from "../../../assets/images/t568a.jpg";

import PowerMeter from "../../../assets/images/power-meter.png";
import TDR from "../../../assets/images/tdr.png";
import Fusao from "../../../assets/images/fusao.png";
import Fusao1 from "../../../assets/images/fusao1.png";

import Montegem1 from "../../../assets/images/montagem1.png";

import './styles.css';



const Cabos = () => {

    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);


    const handleClose = () => setShow(false);
    const handleClose1 = () => setShow1(false);
    const handleClose2 = () => setShow2(false);
    const handleClose3 = () => setShow3(false);
    const handleClose4 = () => setShow4(false);
    const handleClose5 = () => setShow5(false);


    const handleShow = () => setShow(true);
    const handleShow1 = () => setShow1(true);
    const handleShow2 = () => setShow2(true);
    const handleShow3 = () => setShow3(true);
    const handleShow4 = () => setShow4(true);
    const handleShow5 = () => setShow5(true);



    return (
        <div className="container">
            <div className="row">
                <div className="title">
                    <h1>Tipos de cabos de redes</h1>
                    <p>
                        Existem vários tipos de cabos de rede utilizados atualmente, cada um projetado para atender
                        a diferentes necessidades de velocidade e distância de transmissão. Os cabos de rede são
                        geralmente categorizados por padrões, sendo as categorias mais comuns de cabos UTP
                        Cat5e, Cat6, Cat6a e Cat7. Aqui estão alguns dos tipos mais comuns de cabos de rede:
                    </p>
                </div>
                <div className="col-sm-12 col-md-4">
                    <div className="cabos">
                        <img src={CabosImg} alt="cabos" />
                        <img src={CabosEthernet} alt="cabos" />
                        <img src={Gbic} alt="gbic" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-8">
                    <Accordion >
                        <Accordion.Item eventKey="0">
                            <Accordion.Header> Cat5e (Categoria 5e):</Accordion.Header>
                            <Accordion.Body>
                                Suporta até 1 Gigabit por segundo (Gbps) a distâncias de até 100 metros.
                                Ampla utilização em redes domésticas e empresariais para conexões Ethernet.
                                <hr />
                                <Button
                                    variant="outline-primary"
                                    className="mr-sm-2 custom-margin-button"
                                    onClick={handleShow}
                                >
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                </Button>
                                <Modal show={show} onHide={handleClose}>
                                    <Modal.Header closeButton>
                                        <Modal.Title></Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body><Cat5e /></Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>Cat6 (Categoria 6):</Accordion.Header>
                            <Accordion.Body>
                                Suporta até 10 Gbps a distâncias de até 55 metros.
                                Usado para redes Gigabit e 10-Gigabit Ethernet.
                                <hr />
                                <Button
                                    variant="outline-primary"
                                    className="mr-sm-2 custom-margin-button"
                                    onClick={handleShow1}
                                >
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                </Button>
                                <Modal show={show1} onHide={handleClose1}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Cat6 (Categoria 6)</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body><Cat6 /></Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose1}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>Cat6a (Categoria 6a):</Accordion.Header>
                            <Accordion.Body>
                                Suporta até 10 Gbps a distâncias de até 100 metros.
                                Geralmente utilizado em ambientes que exigem maior largura de banda e imunidade a interferências.
                                <hr />
                                <Button
                                    variant="outline-primary"
                                    className="mr-sm-2 custom-margin-button"
                                    onClick={handleShow2}
                                >
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                </Button>
                                <Modal show={show2} onHide={handleClose2}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Cat6a (Categoria 6a)</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body><Cat6a /></Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose2}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>Cat7 (Categoria 7):</Accordion.Header>
                            <Accordion.Body>
                                Suporta até 10 Gbps a distâncias de até 100 metros.
                                Projetado para fornecer maior largura de banda e reduzir a interferência eletromagnética.
                                <hr />
                                <Button
                                    variant="outline-primary"
                                    className="mr-sm-2 custom-margin-button"
                                    onClick={handleShow3}
                                >
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                </Button>
                                <Modal show={show3} onHide={handleClose3}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Cat7 (Categoria 7)</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body><Cat7 /></Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose3}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                            <Accordion.Header>Cat8 (Categoria 8):</Accordion.Header>
                            <Accordion.Body>
                                Suporta até 25/40 Gbps a distâncias curtas (até 30 metros) e 10 Gbps a distâncias de até 100 metros.
                                Projetado para aplicações de data centers e redes empresariais de alta velocidade.
                                <hr />
                                <Button
                                    variant="outline-primary"
                                    className="mr-sm-2 custom-margin-button"
                                    onClick={handleShow4}
                                >
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                </Button>
                                <Modal show={show4} onHide={handleClose4}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Cat8 (Categoria 8)</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body><Cat8 /></Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose4}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="5">
                            <Accordion.Header>Fibra Óptica:</Accordion.Header>
                            <Accordion.Body>
                                Utiliza fibras de vidro ou plástico para transmitir dados usando luz.
                                Oferece alta largura de banda e é imune a interferências eletromagnéticas.
                                Comum em ambientes onde é necessário alto desempenho, como data centers e
                                provedores que utilizam dessa tecnologia para distribuição de internet de alta
                                velocidade para o consumidor final.
                                <hr />
                                <Button
                                    variant="outline-primary"
                                    className="mr-sm-2 custom-margin-button"
                                    onClick={handleShow5}
                                >
                                    <i class="fa fa-file-image-o" aria-hidden="true"></i>
                                </Button>
                                <Modal show={show5} onHide={handleClose5}>
                                    <Modal.Header closeButton>
                                        <Modal.Title></Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body><Fiber /></Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleClose5}>
                                            Close
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="title">
                    <h1>Ferramentas para crimpagem de cabos de redes</h1>
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title-settings">
                        <h4>Conector RJ-45</h4>
                        <img src={Rj45} alt="cabos" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title-settings">
                        <h4>Alicate de Crimpar</h4>
                        <img src={Alicate} alt="cabos" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title-settings">
                        <h4>Keystone</h4>
                        <img src={Keystone} alt="cabos" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title-settings">
                        <h4>Pushdown</h4>
                        <img src={Pushdown} alt="cabos" />
                    </div>
                </div>
                <br />
                <div className="col-sm-12">
                    <div className="sub-title-settings">
                        <h4>Padrões de cores</h4>
                        <img src={T568a} alt="cabos" />
                    </div>
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="title">
                    <h1>Ferramentas para testar cabos de redes</h1>
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>Testador de Cabos</h4>
                    </div>
                    <img src={Testador1} alt="cabos" />
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>Testador de Cabos</h4>
                    </div>
                    <img src={Testador2} alt="cabos" />
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>Testador de Cabos</h4>
                    </div>
                    <img src={Testador3} alt="cabos" />
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>Testador de Cabos</h4>
                    </div>
                    <img src={Testador4} alt="cabos" />
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="title">
                    <h1>Ferramentas para identificar(localizar) cabos de redes</h1>
                </div>
                <div className="col-sm-12 col-md-6">
                    <div className="localizador">
                        <h4>Identificador de Cabos</h4>
                        <img src={Localizador} alt="cabos" />
                    </div>
                </div>
                <div className="col-sm-12 col-md-6">
                    <div className="localizador">
                        <img src={Localizador2} alt="cabos" />
                    </div>
                </div>

            </div>
            <hr />
            <div className="row">
                <div className="title">
                    <h1>Ferramentas para testar e reparar Fibra Óptica</h1>
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>Power Meter</h4>
                    </div>
                    <img src={PowerMeter} alt="cabos" />
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>TDR</h4>
                    </div>
                    <img src={TDR} alt="cabos" />
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>Máquina de Fusão</h4>
                    </div>
                    <img src={Fusao} alt="cabos" />
                </div>
                <div className="col-sm-12 col-md-3">
                    <div className="sub-title">
                        <h4>Máquina de Fusão</h4>
                    </div>
                    <img src={Fusao1} alt="cabos" />
                </div>
            </div>
            <hr />
            <div className="row">
                <div className="title">
                    <h1>Método de montagem</h1>
                </div>


                <div className="col-sm-12">
                    <div className="montagem">
                        <img src={Montegem1} alt="cabos" />
                    </div>
                </div>
                    

            </div>
        </div>
    );
};
export default Cabos;